import { forwardRef, useImperativeHandle } from 'react'

import { useDrawer } from '@maxus/website/components/ui/hooks'
import { cn } from '@maxus/website/utils'

import { ModificationPanel } from './modification-panel'
import type { ModificationDrawerHandle, ModificationDrawerParams } from './type'

export type { ModificationDrawerHandle } from './type'

export * from './modification-manager'

export const ModificationDrawer = forwardRef<ModificationDrawerHandle>((_, ref) => {
  const {
    active,
    entered,
    closing,
    close,
    open,
    params,
  } = useDrawer<ModificationDrawerParams>()

  useImperativeHandle(
    ref,
    () => ({
      open: nextParams => open(nextParams),
    }),
  )

  if (!active || !params) {
    return null
  }

  return (
    <div
      className={cn(
        'fixed inset-0 z-50 flex justify-end bg-black/40 transition-colors',
        (!entered || closing) && 'bg-black/0',
      )}
      onPointerDown={event => {
        if (event.target === event.currentTarget) {
          close()
        }
      }}
    >
      <div
        className={cn(
          'h-full w-125 transition-transform duration-[240ms] ease-out',
          (!entered || closing) && 'translate-x-full',
        )}
        onClick={event => event.stopPropagation()}
        role="dialog"
      >
        <ModificationPanel onClose={close} {...params} />
      </div>
    </div>
  )
})

ModificationDrawer.displayName = 'ModificationDrawer'
